import { gql } from "@apollo/client";

export const GET_INVOICE_WITH_PAGEINATION = gql`
query GetInvoiceWithPagination(
  $page: Int
  $limit: Int
  $classId: ID
  $programId: ID
  $studentId: ID
  $keyword: String
  $academicYearId: ID
  $invoiceId: Int
) {
  getInvoiceWithPagination(
    page: $page
    limit: $limit
    keyword: $keyword
    classId: $classId
    programId: $programId
    studentId: $studentId
    academicYearId: $academicYearId
    invoiceId: $invoiceId,
  ) {
    data {
      _id
      month
      netAmount
      discountAmount
      enrollmentId {
        classId {
          className
          gradeId {
            gradeName
          }
          shiftId {
            shiftName
            shiftNameKh
          }
        }
      }
      studentId {
        lastName
        firstName
        gender
        englishName
        dob
        phoneNumber
        student_id
      }
      classId {
        className
        gradeId {
          gradeName
        }
      }
      totalAmounts
      schoolId {
        schoolName
      }
      additionalFee {
        incomeHead {
          incomeHead
          price
          unit
        }
        countMonth
        startDate
        endDate
        additionalFeeTotal
        discount
        total
      }
      billTo {
        _id
        englishName
        lastName
        firstName
        tel
      }
      void
      invoiceId
      exchangeRate
      groupFeeType
      grossAmount
      startDate
      endDate
      createdAt
      paymentMethod
      paymentDate
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}

`;


export const GET_INVOICE_PAGEINATION = gql`
query GetInvoicePagination($page: Int!, $limit: Int!, $keyword: String!, $from: Date!, $to: Date!) {
  getInvoicePagination(page: $page, limit: $limit, keyword: $keyword, from: $from, to: $to) {
    data {
      _id
      inv
      date
      total
      void
      studentInfo {
        fullName
        khmerId
        latinName
        dateOfBirth
        shift
        tel
        gender
        grade
      }
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;


export const CREATE_INVOICE_FOR_STUDENT = gql`
mutation CreateInvoiceForStudent($input: InvoiceInput) {
  createInvoiceForStudent(input: $input) {
    status
    message
  }
}
`;

export const GET_NEXT_INVOICE_ID = gql`
query Query {
  getNextInvoiceId
}
`;


export const VOID_STUDENT_INVOICE = gql`
mutation VoidStudentInvoice($id: ID!) {
  voidStudentInvoice(_id: $id) {
    status
    message
  }
}
`;

export const GET_SERVICE_TOPAY_NOTIFICATION_BY_STUDENT = gql`
query GetServiceToPayNotificationByStudent($studentId: ID!, $academicYearId: ID!) {
  getServiceToPayNotificationByStudent(studentId: $studentId, academicYearId: $academicYearId) {
    _id
    dateToBePaid
    studentId
    englishName
    firstName
    lastName
    gradeName
    className
    incomeType
    incomeHeadName
    estimateAmount
    verifiedAmount
    isShowMobileApp
  }
}
`
export const UPDATE_MANY_SERVICE_TOPAY_NOTIFICATION_NOT_SHOW = gql`
mutation UpdateManyServiceToPayNotificationNotShowOnMonile($id: [ID]) {
  updateManyServiceToPayNotificationNotShowOnMonile(_id: $id) {
    status
    message
  }
}
`

export const GET_LAST_EXCHANGE_RATE = gql`
query Query {
  getLatestExchangeRate
}
`